import { useCallback, useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useConfig } from './useConfig';

export const useNavigation = () => {
  const { portal } = useConfig();
  const { projectId } = useParams();

  /* Note: navigate can be unstable when switching routes, but we don't want this to cause unneeded reevaluations of consumers, hence we use a ref as a workaround for consumers to stil be able to use the navigate functionality when needed */
  const navigate = useNavigate();
  const navigateRef = useRef(navigate);
  useEffect(() => {
    navigateRef.current = navigate;
  }, [navigate]);

  const goToBuilder = useCallback(
    (alternativeId: string, revisionId: string) =>
      navigateRef.current(`builder/${alternativeId}/version/${revisionId}`),
    [],
  );

  const goToProject = useCallback((projectId: string) => navigateRef.current(`${projectId}`), []);

  const goToPortal = useCallback(
    (redirect = false) => {
      if (portal.url) {
        let { url } = portal;

        if (projectId) {
          url += `/projects/${projectId}/`;
        }

        if (redirect) {
          window.location.href = url;
          return;
        }
        window.window.open(url);
      } else {
        throw new Error('No portal url was found in configuration');
      }
    },
    [projectId, portal],
  );

  return {
    goToBuilder,
    goToPortal,
    goToProject,
  };
};
